import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { DroneManufacturer, MissionProvider } from "@nova/schemas"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { useAppSelector } from "integrations/redux/hooks"
import useSWRMutation from "swr/mutation"

type PrepareFlightRecordUploadBody = {
    files: { fileName: string; fingerprint: string }[]
    manufacturer: DroneManufacturer
    provider: MissionProvider
    pilotUserId: string
}

const prepareFlightRecordUpload = (orgId: string, body: PrepareFlightRecordUploadBody) => {
    return fetchApiGateway("post /org/:orgId/flight-records/prepare", {
        params: { orgId },
        body,
    })
}

export const usePrepareFlightRecordUpload = () => {
    const orgId = useAppSelector(selectActiveWorkspaceId())

    const { trigger, isMutating } = useSWRMutation(
        "prepare-flight-record-upload",
        (key, { arg }: { arg: PrepareFlightRecordUploadBody }) =>
            orgId ? prepareFlightRecordUpload(orgId, arg) : undefined
    )

    return { prepareUpload: trigger, isPreparing: isMutating }
}

type PrepareCsvLogbookUploadBody = {
    fileName: string
    fingerprint: string
}

const prepareCsvLogbookUpload = (orgId: string, body: PrepareCsvLogbookUploadBody) => {
    return fetchApiGateway("post /org/:orgId/csv-logbook/prepare", {
        params: { orgId },
        body,
    })
}

export const usePrepareCsvLogbookUpload = () => {
    const orgId = useAppSelector(selectActiveWorkspaceId())

    const { trigger, isMutating } = useSWRMutation(
        "prepare-csv-logbook-upload",
        (key, { arg }: { arg: PrepareCsvLogbookUploadBody }) =>
            orgId ? prepareCsvLogbookUpload(orgId, arg) : undefined
    )

    return { prepareCsvUpload: trigger, isPreparingCsv: isMutating }
}
